import React from 'react';
import { Text } from '@components/typography';
import { JoykitColor } from '@components/themes';
import { ChevronRightIcon } from '@images/ChevronRight';
import { testimonialsData } from '@data-ts/components/Testimonials';
import {
  TestimonialContainer,
  TestimonialDetails,
  TestimonialAsset,
  TitleWrapper,
  StyledQuotesContainer,
  DetailWrapper,
  TestimonialContent,
  StyledReadMore,
} from './TestimonialCarouselItem.styles';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';

type TestimonialType = {
  title: string;
  author: string;
  imagePath: string;
  readMoreContent?: string;
};

type TestimonialCarouselItemProps = {
  testimonialData: TestimonialType;
  backgroundColor?: JoykitColor;
  isExpanded?: boolean;
  toggleExpanded?: () => void;
};

export const TestimonialCarouselItem: React.FC<TestimonialCarouselItemProps> = props => {
  const { testimonialData, toggleExpanded, isExpanded = false, backgroundColor = 'blue6' } = props;

  return (
    <TestimonialContainer backgroundColor={backgroundColor}>
      <DetailWrapper>
        <TestimonialDetails>
          <TestimonialContent isExpanded={isExpanded}>
            <TitleWrapper>
              <Text tagName="h2" variant="hed72Hero" color="blue3">
                {isExpanded ? testimonialData.title + testimonialData.readMoreContent : testimonialData.title}
              </Text>
              {testimonialData?.readMoreContent && toggleExpanded && (
                <StyledReadMore role="button" onClick={toggleExpanded}>
                  <Text variant="dek15" style={{ fontWeight: 'bold' }} color="blue4" tagName="span">
                    {isExpanded ? testimonialsData.seeLess : testimonialsData.readMore}
                  </Text>
                  <ChevronRightIcon />
                </StyledReadMore>
              )}
            </TitleWrapper>
            <StyledQuotesContainer isExpanded={isExpanded}>
              <Text textAlign="left" tagName="h3" variant="dek20" color="blue3">
                {testimonialData.author}
              </Text>
            </StyledQuotesContainer>
          </TestimonialContent>
        </TestimonialDetails>
      </DetailWrapper>
      <LazyLoadWrapper>
        <TestimonialAsset src={testimonialData.imagePath} />
      </LazyLoadWrapper>
    </TestimonialContainer>
  );
};

export default TestimonialCarouselItem;
